





















import Vue, {VueConstructor} from 'vue'
import {fieldProps} from '../BZCore/ActiveField'
import Errors from '../errors.vue'
import TreeSelectInput from '@/components/Ui/Inputs/TreeSelectInput.vue'


export default (Vue as VueConstructor<Vue & {
  multiSelect: boolean,
  $refs: {
    tree: { reset: () => void },
  }
}>).extend({
  name: 'TreeSelectField',
  props: fieldProps,
  components: {Errors, TreeSelectInput},
  data () {
    return {
      tree: [],
    }
  },
  created () {
    this.makeTree()
  },
  methods: {
    onInput (event: any) {
      if (this.fieldOptions.nodeKey) {
        this.$emit('input', event[this.fieldOptions.nodeKey])
      } else {
        return this.$emit('input', event)
      }
    },
    async makeTree () {
      if (Array.isArray(this.fieldOptions.values)) {
        this.tree = this.fieldOptions.values
      } else if (typeof this.fieldOptions.values === 'function') {
        this.tree = await this.fieldOptions.values(this.scope)
      } else {
        console.error('can not get values list!', this.field, this.scope)
        this.tree = []
      }
    },
    reset () {
      this.$refs.tree.reset()
    }
  },
  watch: {
    scope: {
      handler () {
        this.makeTree()
      },
      deep: true
    },
  },
  computed: {
    currentValue: {
      get (): any {
        if (this.multiSelect && !this.value) {
          return [];
        }
        return [this.value]
      },
      set () {

      }
    },
    treeProps (): any {
      if (this.fieldOptions.treeProps) {
        return this.fieldOptions.treeProps
      } else {
        return {}
      }
    }
  }
})
